export default {
	maxDateMessage: "Date should not be after maximal date.",
	minDateMessage: "Date should not be before minimal date.",
}